import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Location } from '@angular/common';
import { QualitySuites } from 'src/app/shared/model/qualitySuites.model';
import { QualitySuitesService } from 'src/app/shared/service/quality-suites-access.service';
import { SubscriptionLike } from 'rxjs';
import { DialogSearchSSOComponent } from './searchSSO/search-SSO.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-quality-suites-form',
  templateUrl: './quality-suites-form.component.html',
  styleUrls: ['./quality-suites-form.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(window:resize)': 'onWindowResize($event)'
  }
})
export class QualitySuitesFormComponent implements OnInit, OnDestroy {
  qualitySuites: QualitySuites = new QualitySuites();
  qualitySuitesForm: FormGroup;
  request: TicketRequest[] = [];
  isSpin: boolean;
  checkSubmit: boolean;
  subscription: SubscriptionLike;
  width: number = window.innerWidth;
  roles = ['Client', 'PM', 'PO Mag'];
  types = ['Add New Supplier', 'Edit/Update Supplier'];
  businesses = [
    {
      id: 1,
      name: 'Onshore Wind',
      qualitySuites: ['Supplier Deviation Request','Supplier Audit']
    },
    {
      id: 2,
      name: 'Offshore Wind',
      qualitySuites: ['Supplier Deviation Request', 'Non Conformities','Supplier Audit']
    },
    // {
    //   id: 3,
    //   name: 'Grid Solutions',
    //   qualitySuites: ['Part Qualification', 'Non Conformities']
    // },
    {
      id: 4,
      name: 'Hydro',
      qualitySuites: ['Supplier Deviation Request', 'Supplier Qualifications']
    },
  ];
  SQEsso = '';

  ssoDialogRef: MatDialogRef<DialogSearchSSOComponent>;

  constructor(
    private spinner: Spinner,
    private location: Location,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private dialog: MatDialog,
    private service: QualitySuitesService
  ) { }

  ngOnInit(): void {
    this.initFormQualitySuites();
    this.getListTicket();
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestQualitySuitesAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {});
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initFormQualitySuites() {
    return this.qualitySuitesForm = this.fb.group({
      id: [this.qualitySuites.id],
      type: [this.qualitySuites.type, [Validators.required]],
      companyName: [this.qualitySuites.companyName, [Validators.required]],
      name: [this.qualitySuites.name, [Validators.required]],
      SSOID: [this.qualitySuites.SSOID, [Validators.required]],
      email: [this.qualitySuites.email, [Validators.required]],
      business: [this.qualitySuites.business, [Validators.required]],
      qualitySuiteModule: [this.qualitySuites.qualitySuiteModule, [Validators.required]],
      supplierCountryCode: [this.qualitySuites.supplierCountryCode, [Validators.required]],
      supplierCity: [this.qualitySuites.supplierCity, [Validators.required]],
      // zipCode: [this.qualitySuites.zipCode],
      GSLNumber: [this.qualitySuites.GSLNumber, [Validators.required]],
      // vendorCode: [this.qualitySuites.vendorCode],
      // supplierContactName: [this.qualitySuites.supplierContactName],
      // supplierSSOID: [this.qualitySuites.supplierSSOID],
      // supplierEmail: [this.qualitySuites.supplierEmail],
      access: [this.qualitySuites.access, [Validators.required]],
      siteCode: [this.qualitySuites.siteCode, [Validators.required]],
      SQEName: [this.qualitySuites.SQEName, [Validators.required]],
      scxID: [this.qualitySuites.scxID, [Validators.required]],
      jobTitle: [this.qualitySuites.jobTitle],
      phone: [this.qualitySuites.phone],
      extension: [this.qualitySuites.extension],
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitQualitySuitesForm(): void {
    if (this.checkSubmit) {
      this.setErrorForm(this.qualitySuitesForm);
    }
    if (!this.qualitySuitesForm.valid) {
      this.markFormGroupTouched(this.qualitySuitesForm);
      return;
    } else {
      this.openDialog();
    }
  }

  goToApplication() {
    window.open('https://qualitysuite.gevernova.com/');
  }

  getInitFormByID(id) {
    this.spinner.show();
    this.service.getRequestQualitySuitesAccess(id).subscribe((res) => {
      this.spinner.hide();
      this.qualitySuites = new QualitySuites(res.data);
      this.initFormQualitySuites();
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new QualitySuites(this.qualitySuitesForm.getRawValue(), false, this.SQEsso).convertToReqBody();
        this.spinner.show();
        this.service.requestQualitySuitesAccess(body).subscribe((res) => {
          this.service.createSupportCentralForm(res.data).subscribe();
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          setTimeout(() => {
            location.reload();
          }, 3000);
        });
      }
    });
  }

  setErrorForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((name) => {
      if (!formGroup.controls[name].value) {
        formGroup.controls[name].setErrors({ required: true });
      }
    });
    return formGroup;
  }

  selectBusiness($event) {
    this.qualitySuitesForm.controls.qualitySuiteModule.reset();
    this.qualitySuitesForm.controls.GSLNumber.reset();
    if (this.qualitySuitesForm.controls.business.value.id === 4) {
      this.qualitySuitesForm.controls.access.setErrors(null);
      this.qualitySuitesForm.controls.siteCode.setErrors(null);
      this.qualitySuitesForm.controls.SQEName.setErrors(null);
    }
  }

  selectModule($event) {
    if (this.qualitySuitesForm.controls.business.value.id === 4 && this.qualitySuitesForm.controls.qualitySuiteModule.value === 'Supplier Qualifications') {
      this.qualitySuitesForm.controls.access.setValue('N/A');
      this.qualitySuitesForm.controls.scxID.setValue('');
    } else {
      this.qualitySuitesForm.controls.access.setValue('');
      this.qualitySuitesForm.controls.scxID.setValue('N/A');
    }

    if (this.qualitySuitesForm.controls.qualitySuiteModule.value === 'Supplier Audit') {
      this.qualitySuitesForm.controls.supplierCountryCode.setValue('N/A')
      this.qualitySuitesForm.controls.supplierCity.setValue('N/A')
      this.qualitySuitesForm.controls.access.setValue('N/A')
    }
  }

  getSiteCodeBasedOnBusiness() {
    return this.qualitySuitesForm
        && this.qualitySuitesForm.controls
        && this.qualitySuitesForm.controls.business
        && this.qualitySuitesForm.controls.business.value
        && this.qualitySuitesForm.controls.business.value.id === 4
        ? 'Site Code/Vendor Code' : 'Site Code';
  }

  isEnableBaseOnModules(): boolean {
    return this.qualitySuitesForm.controls.qualitySuiteModule.value === 'Supplier Audit';
  }

  isHydroModule2() {
    return this.qualitySuitesForm.controls.business.value.id === 4 && this.qualitySuitesForm.controls.qualitySuiteModule.value === 'Supplier Qualifications';
  }

  searchSSO(event) {
    this.ssoDialogRef = this.dialog.open(DialogSearchSSOComponent, {
      width: this.width > 1000 ? '40%' : '100%',
      maxWidth: '100%',
      maxHeight: '500px',
      data: {}
    });
    this.ssoDialogRef.afterClosed().pipe(
    ).subscribe(result => {
      this.qualitySuitesForm.controls.SQEName.setValue(result.name);
      this.SQEsso = result.sso;
    });
  }

}
